import React from 'react';
import { BadgeCheckIcon, ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#0A0A0A] px-5 py-20" data-id="element-81">
      <div className="mx-auto max-w-3xl border-t-8 border-[#d4af37] bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-82">
        <p className="inline-flex items-center gap-2 bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest" data-id="element-83">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-84" />
          Zéro risque
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-[#b18b18]" strokeWidth={1.4} data-id="element-85" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none sm:text-6xl" data-id="element-86">
          Garantie <span className="text-[#b18b18]" data-id="element-87">7 jours</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-[#5A5A66]" data-id="element-88">
          Ouvrez les 6 Modules, explorez les 5 Bonus et découvrez l’intégralité
          du système.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#0A0A0A]" data-id="element-89">
          Essayez RUGBY PRÊT sans risque. Si vous n’êtes pas entièrement
          satisfait,
          <span className="text-[#b18b18]" data-id="element-90">
            {' '}
            nous vous remboursons 100 % — sans aucune question.
          </span>
        </p>
        <p className="mt-6 inline-block border border-[#d4af37]/50 bg-[#d4af37]/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#9b7914]" data-id="element-91">
          Taux de remboursement inférieur à 1 %
        </p>
      </div>
    </section>;
}